// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"796":"f1a5f26b","966":"6a6a551a"}[chunkId] + ".chunk.js";
};